// extracted by mini-css-extract-plugin
export default {"button":"_5R-q5","icon":"_1BgJo","wrapper":"_2aW2p","label":"qUwgr"};